import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import TermsContent from "./TermsContent";

const Terms: React.FC = () => {
  useEffect(() => {
    document.title = "Terms of Service | SendUpdates";
  }, []);

  return (
    <div className="bg-light py-5">
      <Container style={{ maxWidth: 900 }}>
        <TermsContent />
      </Container>
    </div>
  );
};

export default Terms;
